import React from 'react';
import { Card } from './ui/card';

/**
 * Placard Component - LikeKind expression space
 * Per LIKEKIND_MASTER_SPEC:
 * - Replaces badges system
 * - Photo + short description
 * - For individuals: art, views, work, meaning
 * - For businesses: ad surface
 */
export default function Placard({ placard, isOwner = false, onEdit }) {
  if (!placard) {
    if (isOwner) {
      return (
        <Card 
          className="p-4 border-dashed border-2 border-slate-600 bg-slate-800/30 cursor-pointer hover:border-[var(--lk-terra)] transition-colors"
          onClick={onEdit}
        >
          <div className="text-center text-slate-400">
            <p className="text-sm">Add your placard</p>
            <p className="text-xs mt-1">Share what you value or support</p>
          </div>
        </Card>
      );
    }
    return null;
  }

  return (
    <Card className="overflow-hidden bg-slate-800/50 border-slate-700">
      {placard.image_url && (
        <div className="aspect-video w-full overflow-hidden">
          <img 
            src={placard.image_url} 
            alt="Placard" 
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="p-3">
        <p className="text-sm text-slate-200 leading-relaxed">
          {placard.description}
        </p>
        {isOwner && onEdit && (
          <button 
            onClick={onEdit}
            className="mt-2 text-xs text-[var(--lk-terra)] hover:underline"
          >
            Edit placard
          </button>
        )}
      </div>
    </Card>
  );
}
